import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _isNativeReflectConstruct from "@babel/runtime/helpers/isNativeReflectConstruct";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import { Component, createRef } from 'react';
import { FullscreenProvider } from "./context/Fullscreen";
import { HlsProvider } from "./context/Hls";
import { PictureInPictureProvider } from "./context/PictureInPicture";
import { PlaybackProvider } from "./context/Playback";
import { ResponsiveProvider } from "./context/Responsive";
import { SubtitleProvider } from "./context/Subtitle";
import { UIProvider } from "./context/UI";
import { VisibleActionProvider } from "./context/VisibleAction";
import { VolumeProvider } from "./context/Volume";
import CrehanaPlayer from "./CrehanaPlayer";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This component class is needed in order to access the playback functions from outside.
 */
var CrehanaPlayerClass = /*#__PURE__*/function (_Component) {
  function CrehanaPlayerClass(props) {
    var _this;
    _classCallCheck(this, CrehanaPlayerClass);
    _this = _callSuper(this, CrehanaPlayerClass, [props]);
    // Ref to the html video element
    _this.videoRef = /*#__PURE__*/createRef();
    _this.play = function (byUser) {
      if (_this.videoRef.current && _this.state.isReady) {
        _this.videoRef.current.play();
        if (byUser) {
          _this.setState({
            wasPlaying: true
          });
        }
      }
    };
    _this.pause = function (byUser) {
      if (_this.videoRef.current && _this.state.isReady) {
        _this.videoRef.current.pause();
        if (byUser) {
          _this.setState({
            wasPlaying: false
          });
        }
      }
    };
    _this.togglePlay = function () {
      if (_this.state.isPlaying) {
        _this.pause(true);
      } else {
        _this.play(true);
      }
    };
    _this.seek = function (time) {
      if (_this.videoRef.current) {
        _this.videoRef.current.currentTime = time;
      }
    };
    _this.replay = function () {
      _this.seek(0);
      _this.play(true);
    };
    _this._resetReadyState = function () {
      _this.setState({
        isReady: false,
        isPlaying: false,
        wasPlaying: false
      });
    };
    _this._onReady = function (videoData) {
      var onReady = _this.props.onReady;
      var isReady = _this.state.isReady;

      // Avoid calling onReady more than once
      if (!isReady) {
        _this.setState({
          isReady: true
        });
        if (onReady) {
          onReady(videoData);
        }
      }
    };
    _this._onPlay = function () {
      var onPlay = _this.props.onPlay;
      _this.setState({
        isPlaying: true
      });
      if (_this.videoRef.current && onPlay) {
        onPlay(_this.videoRef.current.currentTime);
      }
    };
    _this._onPause = function () {
      var onPause = _this.props.onPause;
      _this.setState({
        isPlaying: false
      });
      if (_this.videoRef.current && onPause) {
        var _this$videoRef$curren = _this.videoRef.current,
          currentTime = _this$videoRef$curren.currentTime,
          duration = _this$videoRef$curren.duration;
        onPause(currentTime, duration);
      }
    };
    _this.state = {
      isReady: false,
      isPlaying: false,
      wasPlaying: false
    };
    return _this;
  }
  _inherits(CrehanaPlayerClass, _Component);
  return _createClass(CrehanaPlayerClass, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        isReady = _this$state.isReady,
        isPlaying = _this$state.isPlaying,
        wasPlaying = _this$state.wasPlaying;
      return /*#__PURE__*/_jsx(ResponsiveProvider, {
        playerRef: this.props.playerRef,
        defaultPlayerSize: this.props.defaultPlayerSize,
        defaultPlayerHeight: this.props.defaultPlayerHeight,
        disablePlayerSizeCalculation: this.props.disablePlayerSizeCalculation,
        children: /*#__PURE__*/_jsx(FullscreenProvider, {
          playerRef: this.props.playerRef,
          onFullscreen: this.props.onFullscreen,
          orientation: this.props.orientation,
          children: /*#__PURE__*/_jsx(PictureInPictureProvider, {
            videoRef: this.videoRef,
            onPictureInPictureChange: this.props.onPictureInPictureChange,
            children: /*#__PURE__*/_jsx(VisibleActionProvider, {
              children: /*#__PURE__*/_jsx(PlaybackProvider, {
                isReady: isReady,
                isPlaying: isPlaying,
                wasPlaying: wasPlaying,
                videoId: this.props.videoId,
                nextVideo: this.props.nextVideo,
                sources: this.props.sources,
                disableSeekForward: this.props.disableSeekForward,
                onBackward: this.props.onBackward,
                onForward: this.props.onForward,
                onSeek: this.props.onSeek,
                onTimeUpdate: this.props.onTimeUpdate,
                onSpeedChange: this.props.onSpeedChange,
                onSkipVideoEnding: this.props.onSkipVideoEnding,
                endOverlay: this.props.endOverlay,
                defaultSpeed: this.props.defaultSpeed,
                inactivity: this.props.inactivity,
                autoplay: this.props.autoplay,
                videoRef: this.videoRef,
                play: this.play,
                pause: this.pause,
                togglePlay: this.togglePlay,
                replay: this.replay,
                seek: this.seek,
                resetReadyState: this._resetReadyState,
                onReady: this._onReady,
                onPlay: this._onPlay,
                onPause: this._onPause,
                children: /*#__PURE__*/_jsx(HlsProvider, {
                  startPosition: this.props.startPosition,
                  hlsConfig: this.props.hlsConfig,
                  onError: this.props.onError,
                  defaultAudioLang: this.props.defaultAudioLang,
                  onAudioChange: this.props.onAudioChange,
                  defaultQuality: this.props.defaultQuality,
                  onQualityChange: this.props.onQualityChange,
                  onQualityManualChange: this.props.onQualityManualChange,
                  withLowQualityWarning: this.props.withLowQualityWarning,
                  withManualHighQualityWarning: this.props.withManualHighQualityWarning,
                  children: /*#__PURE__*/_jsx(SubtitleProvider, {
                    videoSubtitles: this.props.videoSubtitles,
                    onSubtitlesChange: this.props.onSubtitlesChange,
                    availableSubtitleLanguages: this.props.availableSubtitleLanguages,
                    defaultSubtitleLang: this.props.defaultSubtitleLang,
                    children: /*#__PURE__*/_jsx(VolumeProvider, {
                      defaultMuted: this.props.defaultMuted,
                      defaultVolume: this.props.defaultVolume,
                      onVolumeChange: this.props.onVolumeChange,
                      children: /*#__PURE__*/_jsx(UIProvider, {
                        playerRef: this.props.playerRef,
                        header: this.props.header,
                        hideLogo: this.props.hideLogo,
                        hideSpeedOptions: this.props.hideSpeedOptions,
                        hideSkipButtons: this.props.hideSkipButtons,
                        onUIVisibilityChange: this.props.onUIVisibilityChange,
                        classNotes: this.props.classNotes,
                        hiddenNotes: this.props.hiddenNotes,
                        onHideNotesSwitch: this.props.onHideNotesSwitch,
                        onAddNote: this.props.onAddNote,
                        thumbnails: this.props.thumbnails,
                        pausedOverlay: this.props.pausedOverlay,
                        endOverlay: this.props.endOverlay,
                        onAutoplaySwitch: this.props.onAutoplaySwitch,
                        onEndOverlayVisibilityChange: this.props.onEndOverlayVisibilityChange,
                        onAddNoteAI: this.props.onAddNoteAI,
                        onSaveNoteAI: this.props.onSaveNoteAI,
                        canWarningNoteAI: this.props.canWarningNoteAI,
                        visibleAI: this.props.visibleAI,
                        amplitudAI: this.props.amplitudAI,
                        children: /*#__PURE__*/_jsx(CrehanaPlayer, {
                          playerRef: this.props.playerRef,
                          className: this.props.className,
                          htmlProps: this.props.htmlProps,
                          forcePlayerErrorState: this.props.forcePlayerErrorState,
                          poster: this.props.poster,
                          orientation: this.props.orientation,
                          aspectRatio: this.props.aspectRatio,
                          inactivity: this.props.inactivity,
                          publicNotes: this.props.publicNotes
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      });
    }
  }]);
}(Component);
export default CrehanaPlayerClass;